import SvgFigurePreview from '../FigureEditor/svg/SvgFigurePreview';

const labels = { keep: '유지', replace: '교체', failed: '실패' };

/** 검수 응답의 부가 정보다. 수정 PATCH에는 보내지 않는다. */
export default function FigureResults({ figures }) {
  if (!Array.isArray(figures) || figures.length === 0) return null;
  return <section aria-label="그림 처리 결과" className="space-y-2 rounded-xl border border-gray-200 p-3">
    <h3 className="text-xs font-semibold text-gray-700">그림 처리 결과</h3>
    <p className="text-xs text-gray-500">그림은 승인 후 문제은행에서 편집할 수 있습니다.</p>
    {figures.map((figure, index) => <div key={`${figure.figure_ref || 'figure'}-${index}`} className="flex items-start gap-3 border-t border-gray-100 pt-2">
      {figure.op !== 'failed' && (figure.src || figure.svg_text) && <SvgFigurePreview
        src={figure.src} svgText={figure.src ? undefined : figure.svg_text}
        alt={`그림 ${index + 1}`} className="max-h-24 max-w-24 object-contain" />}
      <div className="min-w-0 space-y-1 text-xs">
        <p className={figure.op === 'failed' ? 'font-medium text-danger' : 'font-medium text-gray-700'}>
          그림 {index + 1} · {labels[figure.op] || '결과 확인 필요'}
        </p>
        {figure.figure_ref && <p className="break-all text-gray-500">그림 참조: {figure.figure_ref}</p>}
        {Array.isArray(figure.issues) && figure.issues.length > 0 && <ul className="list-disc pl-4 text-danger">
          {figure.issues.map((issue, n) => <li key={n}>{String(issue)}</li>)}
        </ul>}
      </div>
    </div>)}
  </section>;
}

export function figureApprovalError(error) {
  const { reason, figure_refs: refs, code } = error?.data || {};
  if (reason === 'figure_failed') return `완성되지 않은 그림이 있어 승인하지 못했습니다.${Array.isArray(refs) && refs.length ? ` 해당 그림: ${refs.join(', ')}.` : ''} 그림을 다시 만들거나 해당 블록을 제거한 뒤 승인해 주세요.`;
  if (reason === 'svg_rejected') return `그림이 검사를 통과하지 못했습니다. ${error.message || '그림을 확인해 주세요.'}${code ? ` (${code})` : ''}`;
  if (reason === 'image_placeholder') return '본문이나 풀이에 [그림] 자리가 남아 있습니다. 그림을 채우거나 해당 블록을 제거한 뒤 승인해 주세요.';
  return error?.message || '승인에 실패했습니다.';
}
